import { useState } from 'react'
import { AppDialog } from './AppDialog'
import { setLeaveForHubConfirmed, type HubKey } from '../../utils/leaveForHub'

export type { HubKey }

export interface LeaveForHubDialogProps {
  open: boolean
  hubKey: HubKey
  hubName: string
  onConfirm: () => void
  onCancel: () => void
}

export const LeaveForHubDialog = ({
  open,
  hubKey,
  hubName,
  onConfirm,
  onCancel,
}: LeaveForHubDialogProps) => {
  const [dontAskAgain, setDontAskAgain] = useState(false)

  const handleConfirm = () => {
    if (dontAskAgain) {
      setLeaveForHubConfirmed(hubKey)
    }
    onConfirm()
  }

  return (
    <AppDialog
      open={open}
      title={`Leave for ${hubName}?`}
      onDismiss={onCancel}
      actions={[
        {
          label: 'Cancel',
          variant: 'ghost',
          onClick: onCancel,
        },
        {
          label: `Go to ${hubName}`,
          variant: 'primary',
          onClick: handleConfirm,
        },
      ]}
      message={
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <p style={{ margin: 0, fontSize: 14, color: 'var(--text-strong)', lineHeight: 1.5 }}>
            You're about to leave for the {hubName} page. Understood?
          </p>
          <label
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 13,
              color: 'var(--muted)',
              cursor: 'pointer',
              userSelect: 'none',
            }}
          >
            <input
              type="checkbox"
              checked={dontAskAgain}
              onChange={(e) => setDontAskAgain(e.target.checked)}
              style={{ cursor: 'pointer' }}
            />
            <span>Don't ask again this session</span>
          </label>
        </div>
      }
    />
  )
}
